import { render, staticRenderFns } from "./EnvelopeSimple.vue?vue&type=template&id=29cdef7c"
import script from "./EnvelopeSimple.vue?vue&type=script&lang=js"
export * from "./EnvelopeSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports